'use strict';

import $ from 'jquery';

/**
 * Handle product size list metric/imperial conversion
 */
let conversion = {
  init: function() {
    $('.js-conversion').on('click', function (event) {
      const $button = $(event.target);
      const type = $button.data('type');

      $('.is-metric, .is-imperial').hide();
      $('.is-' + type).show();

      $('.js-conversion').removeClass('active');
      $button.addClass('active');
    });
  }
};

export default conversion;
